"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var constants_1 = require("../config/constants");
var wix_experiments_1 = require("@wix/wix-experiments");
var ExperimentsController = /** @class */ (function () {
    function ExperimentsController() {
    }
    ExperimentsController.getExperiments = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, getExperimentsByScope(constants_1.EXPERIMENTS_SCOPE)];
            });
        });
    };
    return ExperimentsController;
}());
function getExperimentsByScope(scope) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var experiments;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    experiments = new wix_experiments_1.default({
                        scope: scope,
                    });
                    return [4 /*yield*/, experiments.ready()];
                case 1:
                    _a.sent();
                    return [2 /*return*/, experiments.all()];
            }
        });
    });
}
exports.default = ExperimentsController;
//# sourceMappingURL=ExperimentsController.js.map